module.exports = __webpack_public_path__ + "img/slogan.68b3ef52.svg";